// extracted by mini-css-extract-plugin
export default {"message":"Notification_message__iUHOw"};